import React from "react";
import CSAEContainer from "../containers/CSAE";

const CSAE: React.FC = () => {
    return <CSAEContainer />;
};

export default CSAE; 